import { GridSpacing, useBreakpoint } from '@percept/mui'

import { DocumentTitleHookProps, useDocumentTitle } from '@percept/hooks'

import { AppBranding } from '@percept/types'


const { BRANDING } = process.env

export const useLayoutGridSpacing = (): GridSpacing => {
  const breakpoint = useBreakpoint()
  switch(breakpoint){
    case 'sm': return 4
    case 'md': return 2
    case 'lg': return 3
    default: return 5
  }
}


const brandingTitleMap: Partial<Record<AppBranding, string>> = {
  PERCEPT: 'Percept',
  TPA: 'TPA Audit',
  BRANDTECH: 'Brandtech Media Group',
  VODAFONE: 'Vodafone Media Wizard',
  APERTO: 'Aperto',
}

export const useDashboardPageTitle = (props: DocumentTitleHookProps): void => {
  useDocumentTitle({
    site: brandingTitleMap[BRANDING || 'PERCEPT'],
    ...props,
  })
}
